import css from "csstype";

const table: css.Properties = {
  border: "1px solid rgb(227, 227, 227)",
  margin: "0 0 1rem 0",
  width: "fit-content",
  minWidth: "91vw",
};
const employeTable: css.Properties = {
  border: "1px solid rgb(227, 227, 227)",
  margin: "0 0 1rem 0",
  minWidth: "45.5vw",
  marginBottom: "1rem"
};
const tableHeader: css.Properties = {
  padding: "0.5rem 0.5rem",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  width: "100%",
};
const tableTxt: css.Properties = {
  width: "100%",
  margin: "1rem 0",
};
const tableHeadTxt: css.Properties = {
  margin: "1rem 2rem 1rem 0",
};
const employeeTableHead: css.Properties = {
  width: "100%",
  margin: "1rem 0",
};
const addEmployeeBtn: css.Properties = {
  marginRight: "1rem",
};
const tableContainer: css.Properties = {
  border: "1px solid rgb(227, 227, 227)",
  margin: "0 0 1rem 0",
  width: "93vw",
}
const buttonBack: css.Properties = {
  width: "3rem",
  height: "2rem",
  marginBottom: "0.5rem"
}
const tableFilterContainer: css.Properties = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  margin: ".5rem 0 .5rem 0"
}
const tableFilter: css.Properties = {
  width: "12rem",
  flexShrink: 0,
}
const tableFilterYear: css.Properties = {
  width: "5.25rem",
  flexShrink: 0,
}
const tableWithFiltersHeader: css.Properties = {
  padding: "0 0.5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  width: "100%",
  minWidth: 0,
};
const expectedHoursToolbarRow: css.Properties = {
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
  gap: "0.5rem",
  margin: ".5rem 0 .5rem 0",
  width: "100%",
  minWidth: 0,
  overflowX: "auto",
};
const filtersContainer: css.Properties = {
  display: "flex",
  gap: "1rem",
  alignItems: "end",
  margin: "0",
  flexWrap: "wrap"
};
const filterButton: css.Properties = {
  height: "2rem"
};
const tableHeaderWrapper: css.Properties = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between"
};
const assignmentsTableHeader: css.Properties = {
  padding: "0.5rem 0.5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  maxWidth: "100%",
}
const addAssignmentButton: css.Properties = {
  maxHeight: "2rem",
  alignSelf: "center"
}
const employeesCard: css.Properties = {
  marginBottom: "2rem"
}
const hiddenFileInput: css.Properties = {
  display: "none",
};
const lastUpdatedAbsentifyImportText: css.Properties = {
  marginTop: "8px",
  fontSize: "14px",
};

const statusHeaderCell: css.Properties = {
  width: "260px",
  minWidth: "200px",
  maxWidth: "320px",
};

const actionsHeaderCell: css.Properties = {
  width: "56px",
  minWidth: "56px",
  maxWidth: "72px",
  textAlign: "center",
};

const headerTooltipLabel: css.Properties = {
  position: "relative",
  display: "inline-block",
  maxWidth: "100%",
  paddingRight: "20px",
  lineHeight: 1.2,
};

const headerTooltipText: css.Properties = {
  display: "inline",
  whiteSpace: "normal",
  wordBreak: "break-word",
};

const headerTooltipIcon: css.Properties = {
  position: "absolute",
  top: "0",
  right: "0",
  zIndex: 1,
  cursor: "help",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: "14px",
  height: "14px",
  minWidth: "14px",
  minHeight: "14px",
  maxWidth: "14px",
  maxHeight: "14px",
  flexShrink: 0,
  borderRadius: "50%",
  border: "1px solid #605e5c",
  color: "#605e5c",
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: 1,
  boxSizing: "border-box",
};

const styles = {
  table,
  tableHeader,
  tableTxt,
  addEmployeeBtn,
  tableHeadTxt,
  tableWithFiltersHeader,
  expectedHoursToolbarRow,
  employeTable,
  employeeTableHead,
  tableContainer,
  buttonBack,
  tableFilterContainer,
  tableFilter,
  tableFilterYear,
  filtersContainer,
  filterButton,
  tableHeaderWrapper,
  assignmentsTableHeader,
  addAssignmentButton,
  employeesCard,
  hiddenFileInput,
  lastUpdatedAbsentifyImportText,
  statusHeaderCell,
  actionsHeaderCell,
  headerTooltipLabel,
  headerTooltipText,
  headerTooltipIcon,
};

export default styles;
